import Joi from 'joi-browser';

const csvRequestSchema = Joi.object().keys({
  company_branch_ids: Joi.array()
    .min(1)
    .required(),
  csv_type: Joi.any().required(),
  field_ids: Joi.array()
    .min(1)
    .required(),
  from_date: Joi.any().required(),
  to_date: Joi.any().required(),
});

export default csvRequestSchema;



// WEBPACK FOOTER //
// ./src/utilities/validationSchemas/csvRequest.js